import form from "../Form.module.css";
import { FieldExecutionTier } from "./FieldExecutionTier";
import { CostNotificationForQuery } from "./CostNotificationForQuery";
import { CostNotificationForDashboard } from "./CostNotificationForDashboard";

import type { ActiveContext } from "shared/ContextSwitcher/store";
import type { ExecutionTiersData } from "shared/SelectPerformance/useGetPerformanceTiers";
import type { FormState } from "../FormState";
import type { Dispatch, SetStateAction } from "react";

export { CostNotificationForQuery };
export { CostNotificationForDashboard };

export interface Cost {
  monthlyCredits: number;
  planMonthlyCredits: number;
}

interface Props<FState> {
  contextOwner: ActiveContext;
  performanceTiers: ExecutionTiersData[];

  state: FState;
  setState: Dispatch<SetStateAction<FState>>;

  CostNotification:
    | typeof CostNotificationForQuery
    | typeof CostNotificationForDashboard;
  cost: Cost;
}

export function TierAndCost<FState extends FormState>(props: Props<FState>) {
  const {
    contextOwner,
    performanceTiers,
    state,
    setState,
    CostNotification,
    cost,
  } = props;

  return (
    <>
      <div className={form.row}>
        <FieldExecutionTier
          contextOwner={contextOwner}
          performanceTiers={performanceTiers}
          selectedPerformance={state.performanceTier}
          setSelectedPerformance={(performanceTier) =>
            setState((state) => ({ ...state, performanceTier }))
          }
        />
      </div>

      <CostNotification
        contextOwner={contextOwner}
        performanceTiers={performanceTiers}
        state={state}
        cost={cost}
      />
    </>
  );
}
